import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61771dcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-number"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.userConfig.showPageNumber)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($setup.props.page + '/' + $setup.props.count), 1 /* TEXT */))
    : _createCommentVNode("v-if", true)
}